import { useEffect, useState } from 'react';
import useBusinessPostApi from '../../lib/useBusinessPostApi.js';
import { setOtherIntegrationsQuery } from '../../lib/Queries';
import { CheckCircleIcon } from '@heroicons/react/24/solid/index.js';
import Modal from '../Modal';
import Loading from '../Loading';
import ErrorMessageBlock from '~/components/ErrorMessageBlock';
import IntegrationBlock from '~/components/integrations/IntegrationBlock';

const IntegrationSettingsBlock = ({
    title,
    description,
    icon,
    isConnected,
    integrationKey,
    settings,
    getSettingsContent,
    isLoading,
    hideSave,
    error,
}) => {
    const [localSettings, setLocalSettings] = useState({});
    const [isOpen, setIsOpen] = useState(false);

    const { save, isSaving } = useBusinessPostApi(
        `/integrations/other/${integrationKey}`,
    );

    useEffect(() => {
        if (!isOpen) {
            // Don't clobber if we're editing
            setLocalSettings(settings);
        }
    }, [JSON.stringify(settings)]);

    function submit(ev) {
        ev.preventDefault();
        if (hideSave) {
            return;
        }

        save({
            settings: localSettings,
        }).then(result => {
            setOtherIntegrationsQuery(result);
            setIsOpen(false);
        });
    }

    return (
        <>
            <IntegrationBlock
                icon={icon}
                title={title}
                error={error}
                description={description}
                footer={
                    <div className="flex items-center justify-between">
                        {!isLoading && (
                            <button
                                type="button"
                                className="btn-light-pill"
                                onClick={() => setIsOpen(true)}
                            >
                                {isConnected ? 'Manage' : 'Connect'}
                            </button>
                        )}
                        {isLoading && <Loading />}
                        {isConnected && (
                            <div className="text-green-500 flex items-center">
                                <CheckCircleIcon className="w-5 h-5 mr-1" />
                                Connected
                            </div>
                        )}
                    </div>
                }
            />

            <Modal
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                widthClass="sm:max-w-[600px]"
            >
                <div className="flex items-center mb-6">
                    <div className="w-8 h-8 mr-3">{icon}</div>
                    <div className="text-lg font-medium">{title}</div>
                </div>
                <form onSubmit={submit}>
                    {getSettingsContent({
                        settings: localSettings,
                        setSettings: setLocalSettings,
                    })}
                    {!hideSave && (
                        <div className="mt-4">
                            <button className="btn-save">
                                {isSaving ? 'Saving...' : 'Save'}
                            </button>
                        </div>
                    )}
                </form>
            </Modal>
        </>
    );
};

export default IntegrationSettingsBlock;
